export const environment = {
  production: true,
  apiUrl: 'https://bookingsystemapi.motasoftvgm.co.uk',
  versionNumber: '#{buildVersion}#',
  //apiUrl: 'http://192.168.0.42:12000',
  assetsUrl: 'https://booking-system.motasoftvgm.co.uk/assets',
  baseUrl: 'https://booking-system.motasoftvgm.co.uk/#/',
  name: 'production',
  rollbarLogging: true
};